;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import get from "lodash/get"

import StackSpaced from "../../../../pages/loginAndSignUp/shared/StackSpaced"
import ColorButton from "../../../../pages/loginAndSignUp/shared/ColorButton"
import TextField from "@mui/material/TextField"
import Checkbox from "@mui/material/Checkbox"
import FormControlLabel from "@mui/material/FormControlLabel"
import { signUp } from "../../../../../lib/auth/authActions"
// import { CONVERSION_EVENT_CREATE_ACCOUNT, logEvent } from "../../../Analytics"
import { signUpEmailVar } from "../../../../../graphql/reactiveVars"
import updateSuccessMessage from "../../../../../graphql/mutations/snackbarMessage/updateSuccessMessage"
import updateErrorMessage from "../../../../../graphql/mutations/snackbarMessage/updateErrorMessage"
import Link from "next/link"
// import * as Sentry from "@sentry/nextjs"
// import {
//   USER_AGREES_TO_TOU_AND_PP,
//   SCOPE_LEVEL_INFO,
// } from "../../../../lib/constants/logging"
import {
  TERMS_OF_USE_URL,
  PRIVACY_POLICY_URL,
  UI_STYLE_PRIMARY_BLUE_BLACK,
} from "../../../../../lib/constants"
import { useRouter } from "next/navigation"

const EMAIL = "Email"
const FIRST_NAME = "First Name"
const LAST_NAME = "Last Name"

export default function CreateBasicUserInfo({
  onSignUpPage,
  email,
  password,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  notificationsChecked,
  setNotificationsChecked,
  policiesChecked,
  setPoliciesChecked,
  visible,
  onViewCreateAccount,
  onSuccess,
  redirectToLeader,
  cohortIdParam,
  startTransition,
}) {
  const router = useRouter()
  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value)
  }

  const handleLastNameChange = (event) => {
    setLastName(event.target.value)
  }
  const handlePoliciesCheckedChange = (event) => {
    setPoliciesChecked(event.target.checked)
  }

  const renderDisabledEmail = () => {
    return (
      <TextField
        variant="outlined"
        fullWidth={true}
        label={EMAIL}
        //   type={getType(EMAIL)}
        value={email}
        disabled={true}
        sx={{ maxWidth: "308px", marginTop: "20px", marginBottom: "20px" }}
      />
    )
  }
  const renderPoliciesAcceptedCheckboxForm = () => {
    return (
      <div className={"my-[20px] w-full"}>
        <FormControlLabel
          control={
            <Checkbox
              checked={policiesChecked}
              onChange={handlePoliciesCheckedChange}
              slotProps={{ input: { "aria-label": "controlled" } }}
              // color={UI_STYLE_PRIMARY_BLUE_BLACK}
              sx={{
                color: UI_STYLE_PRIMARY_BLUE_BLACK,
                "&.Mui-checked": {
                  color: UI_STYLE_PRIMARY_BLUE_BLACK,
                },
              }}
            />
          }
          label={
            <div>
              I agree with ZestLife's{" "}
              <Link href={TERMS_OF_USE_URL}>service terms</Link>,{" "}
              <Link href={PRIVACY_POLICY_URL}>privacy policy</Link>
            </div>
          }
        />
      </div>
    )
  }
  const renderFirstNameLastName = () => {
    return (
      <StackSpaced spacing={2}>
        <TextField
          key={"first-name-cr-b-user-info"}
          variant="outlined"
          value={firstName}
          fullWidth={true}
          label={FIRST_NAME}
          // type={getType(FIRST_NAME)}
          onChange={(event) => handleFirstNameChange(event)}
          sx={{ maxWidth: "308px" }}
        />

        <TextField
          key={"last-name-cr-b-user-info"}
          variant="outlined"
          value={lastName}
          fullWidth={true}
          label={LAST_NAME}
          // type={getType(LAST_NAME)}
          // error={isInvalid(LAST_NAME, false)}
          // helperText={isInvalid(LAST_NAME, true)}
          onChange={(event) => handleLastNameChange(event)}
          sx={{ maxWidth: "308px" }}
        />
      </StackSpaced>
    )
  }

  const renderEnrollInNotificationsSwitch = () => {
    return (
      <div className={"mb-[20px] w-full"}>
        <FormControlLabel
          control={
            <Checkbox
              checked={notificationsChecked}
              onChange={handleNotificationsChange}
              slotProps={{ input: { "aria-label": "controlled" } }}
              sx={{
                color: UI_STYLE_PRIMARY_BLUE_BLACK,
                "&.Mui-checked": {
                  color: UI_STYLE_PRIMARY_BLUE_BLACK,
                },
              }}
            />
          }
          label={
            <div>
              Receive curated digests of new groups by fellow providers periodically
              (typically bi-monthly).
            </div>
          }
        />
      </div>
    )
  }
  const handleNotificationsChange = (event) => {
    setNotificationsChecked(event.target.checked)
  }
  const handleSubmitClick = async () => {
    if (!firstName) {
      updateErrorMessage("Enter a first name")
      return
    }

    if (!lastName) {
      updateErrorMessage("Enter a last name")
      return
    }
    if (!policiesChecked) {
      updateErrorMessage("Please agree to our policies.")
      return
    }
    try {
      startTransition(async () => {
        const result = await signUp({
          email,
          password,
          firstName,
          lastName,
          redirectToLeader,
          newsletter: notificationsChecked,
          checkoutCohortId: cohortIdParam,
        })

        if (result.success) {
          signUpEmailVar(email)
          updateSuccessMessage("Check email for confirmation code")
          onSuccess()
        } else {
          if (
            result?.message === "An account with the given email already exists."
          ) {
            updateErrorMessage(
              "An account with the given email already exists. Please log in.",
            )
            router.push("/login")
          } else if (result?.message) {
            updateErrorMessage({
              message: get(result, "message", "Error occured. Please try again."),
              trackToSentry: true,
            })
          }
        }
      })
    } catch (error) {
      updateErrorMessage({
        message: get(error, "message", "Error occurred. Please try again."),
        trackToSentry: true,
        error,
      })
    }
  }

  const renderSubmitButton = () => {
    return (
      <ColorButton
        onClick={handleSubmitClick}
        variant="contained"
        color="primary"
        // disabled={disabled}
      >
        Sign up
      </ColorButton>
    )
  }
  const handleBackButtonClick = () => {
    onViewCreateAccount()
  }

  return (
    <div
      className={
        visible
          ? "flex flex-col items-center justify-center w-full max-w-[500px]"
          : "hidden"
      }
    >
      {renderFirstNameLastName()}
      {renderDisabledEmail()}
      {renderPoliciesAcceptedCheckboxForm()}
      {renderEnrollInNotificationsSwitch()}
      {renderSubmitButton()}
    </div>
  )
}
